import { Component, inject, Input } from '@angular/core';
import { AuthenticationService } from 'src/shared/services/auth/auth_service';
import { BannerComponent } from '../../design/banner/banner.component';
import { TitleComponent } from '../../design/title/title.component';

@Component({
  selector: 'app-resetpassword-link-sent',
  templateUrl: './resetpassword-link-sent.component.html',
  imports: [TitleComponent, BannerComponent],
})
export class ResetpasswordLinkSentComponent {
  private readonly authenticationService = inject(AuthenticationService);

  @Input() email!: string;
  loading!: boolean;
  error!: string;
  sentAgain: boolean = false;

  resendEmail() {
    this.error = '';
    this.loading = true;
    this.authenticationService
      .sendPasswordResetEmail(this.email)
      .catch((error) => this.handlerError(error.message))
      .then(() => this.next());
  }

  next() {
    this.sentAgain = true;
  }

  handlerError(error: string) {
    this.error = error;
  }
  clearSentAgain() {
    this.sentAgain = false;
  }
  clearError() {
    this.error = '';
  }
}
